import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useApiQuery, useApiPut, useApiDelete } from '../../../../api/hooks';
import { useTabsNavigationStore } from '../../../../stores';
import LabeledInput from '../controls/LabeledInput';

const UPDATE_URL = '/api/camps/admin/smena/update';

// Форма настроек смены: название, даты, сохранение/удаление.
export default function ShiftForm({ shift, refetchShifts }) {
    const setShift = useTabsNavigationStore(state => state.setShift);

    const { data: smenaData, refetch } = useApiQuery(
        ['smena', shift.id],
        `/api/camps/public/smena/${shift.id}`
    );

    const [form, setForm] = useState({
        title: shift.title || '',
        startDate: shift.startDate || '',
        endDate: shift.endDate || ''
    });

    useEffect(() => {
        if (smenaData) {
            setForm({
                title: smenaData.title || '',
                startDate: smenaData.startDate || '',
                endDate: smenaData.endDate || ''
            });
        }
    }, [smenaData]);

    const updateSmena = useApiPut({
        successMessage: 'Сохранено',
        withPreloader: true,
        onSuccess: async () => {
            await refetchShifts();
            refetch();
        }
    });

    const deleteSmena = useApiDelete({
        successMessage: 'Смена удалена',
        withPreloader: true,
        onSuccess: async () => {
            await refetchShifts();
            setShift(null);
        }
    });

    const setField = (field) => (e) => setForm({ ...form, [field]: e.target.value });

    const handleSave = () => {
        updateSmena.mutate({
            url: UPDATE_URL,
            data: { id: shift.id, title: form.title, startDate: form.startDate, endDate: form.endDate }
        });
    };

    const handleDelete = () => {
        deleteSmena.mutate({ url: `/api/camps/admin/smena/${shift.id}` });
    };

    return (
        <section className="set-card">
            <h2>Настройки смены</h2>
            <LabeledInput
                className="set-field"
                label="Название смены"
                value={form.title}
                onChange={setField('title')}
            />
            <div className="set-row2">
                <LabeledInput label="Дата начала" type="date" value={form.startDate} onChange={setField('startDate')} />
                <LabeledInput label="Дата окончания" type="date" value={form.endDate} onChange={setField('endDate')} />
            </div>
            <div className="set-acts">
                <button type="button" className="btn btn-danger" onClick={handleDelete} disabled={deleteSmena.isPending}>
                    Удалить
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSave} disabled={updateSmena.isPending}>
                    Сохранить
                </button>
            </div>
        </section>
    );
}

ShiftForm.propTypes = {
    shift: PropTypes.shape({
        id: PropTypes.number.isRequired,
        title: PropTypes.string,
        startDate: PropTypes.string,
        endDate: PropTypes.string
    }).isRequired,
    refetchShifts: PropTypes.func.isRequired
};
